/* eslint-disable react/jsx-props-no-spreading */
import { Children, ForwardedRef, forwardRef } from 'react';
import {
  List,
  MenuWrapper,
  OptionsTitle,
  RowItem,
  Wrapper,
} from './option-list.styled';

type OptionListProps = {
  children: JSX.Element | JSX.Element[] | undefined,
  onClick: () => void,
  activeIndex: number | null,
  onMouseEnter: (index:number) => void,
  onMouseLeave: () => void,
  optionsTitle: string,
}

export const OptionList = forwardRef(({
  children,
  onClick,
  activeIndex,
  onMouseEnter,
  onMouseLeave,
  optionsTitle,
  ...otherProps
}: OptionListProps,
ref:  ForwardedRef<HTMLDivElement>) => {
  const childrenLength = Children.count(children);

  if (children && childrenLength > 0) {
    return (
      <MenuWrapper
        ref={ ref }
        { ...otherProps }
      >
        <Wrapper>
          {!!optionsTitle && (
            <OptionsTitle>
              { optionsTitle }
            </OptionsTitle>
          )}
          <List>
            {
              Children.map(children,
                (optionItem:JSX.Element, index) => (
                  <RowItem
                    id={ `${index}` }
                    key={ optionItem.key }
                    onClick={ onClick }
                    isActive={ index === activeIndex }
                    isLastItem={ index === childrenLength - 1 }
                    onMouseEnter={ () => onMouseEnter(index) }
                    onMouseLeave={ onMouseLeave }
                  >
                    {optionItem}
                  </RowItem>
                ))
            }
          </List>
        </Wrapper>
      </MenuWrapper>
    );
  }

  return null;
});

OptionList.displayName = 'OptionList';
